// extracted by mini-css-extract-plugin
export default {"root":"ReviewDetails-module-root-jO2te","product":"ReviewDetails-module-product-hAqvE","content":"ReviewDetails-module-content-WuoJ7","footer":"ReviewDetails-module-footer-T96Xu"};